import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
  HostListener,
  input,
  Input,
  signal,
} from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { Transaction } from '../../Interfaces/interfaces';
import { CommonModule } from '@angular/common';
import { ApiCallService } from '../../Services/api-call-service.service';
import { LoaderComponent } from '../../components/loader/loader.component';
import { LoaderService } from '../../Services/loader-service.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ToastrService } from 'ngx-toastr';
import { GameService } from '../../Services/game.service';
import { UtilsService } from '../../Services/utils.service';
import { LocalTimePipe } from '../../Pipes/local-time.pipe';
import { loadStripe, Stripe, StripeElements, StripeCardElement } from '@stripe/stripe-js';
import {
  faCheck,
  faCircleInfo,
  faEye,
  faEyeSlash,
  faSackDollar,
  faSurprise,
} from '@fortawesome/free-solid-svg-icons';
import { ErrorhandlingService } from '../../Services/error-handling.service';
import { paymentTypes } from '../../constants/PaymentTypes';
import { debug } from 'console';
import { KycPopupComponent } from '../kyc-popup/kyc-popup.component';
import { Router } from '@angular/router';

declare var Square: any;

@Component({
  selector: 'app-add-wallet',
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    LoaderComponent,
    FontAwesomeModule,
    KycPopupComponent,
  ],
  templateUrl: './add-wallet.component.html',
  styleUrl: './add-wallet.component.scss',
})
export class AddWalletComponent implements OnInit, AfterViewInit {

  stripe: Stripe | null = null;
  elements: StripeElements | null = null;
  infoIcon = faCircleInfo;
  surpriseIcon = faSurprise;
  sackDollarIcon = faSackDollar;
  faCheck = faCheck;
  hasSpecificAccount(accounts: string[]): boolean {
    return this.AccountType?.some((a: any) => accounts.includes(a.name)) ?? false;
  }
  hasExcludedAccounts(excludedAccounts: string[]): boolean {
    return this.AccountType?.some((a: any) => !excludedAccounts.includes(a.name)) ?? false;
  }
  showDateFilter: boolean = false;
  startDate: string | null = null;
  endDate: string | null = null;
  paymentForm: FormGroup;
  paymentFormSquare: FormGroup;
  cashappForm: FormGroup;
  squareForm: FormGroup;
  CashApp2Form: FormGroup;
  squarecashForm: FormGroup;
  showKycPopup: boolean = false;
  private payments: any;
  private cashAppPay: any;

  constructor(
    private apiCallService: ApiCallService,
    private loaderService: LoaderService,
    private toastr: ToastrService,
    private handleError: ErrorhandlingService,
    private GameService: GameService,
    private utilsService: UtilsService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private _errorHandleService: ErrorhandlingService,
    private router: Router
  ) {

    this.paymentForm = this.fb.group({
      cardNumber: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d{13,16}$/), // Basic pattern for 13-16 digits
        ],
      ],
      month: [
        '',
        [
          Validators.required,
          Validators.min(1),
          Validators.max(12),
          Validators.pattern(/^\d{1,2}$/),
        ],
      ],
      year: [
        '',
        [
          Validators.required,
          Validators.min(new Date().getFullYear()), // Min year is current year
          Validators.max(2099),
          Validators.pattern(/^\d{4}$/), // Enforce 4-digit year
        ],
      ],
      cvv: ['', [Validators.required, Validators.pattern(/^\d{3,4}$/)]],
      amount: [
        '',
        [
          Validators.required,
          Validators.min(1),
        ],
      ],
      // Naye Billing Fields yahan add ho gaye hain
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      address: ['', [Validators.required]],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      country: ['US', [Validators.required]], // Default 'US' rakha hai
      zipCode: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      phoneNumber: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]]
    });

    this.paymentFormSquare = this.fb.group({
      amount: ['', [Validators.required, Validators.min(1)]],
      fullName: ['', Validators.required],
      streetAddress: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zip: ['', Validators.required],
      country: ['United States', Validators.required]
    });

    this.cashappForm = this.fb.group({
      amount: ['', [Validators.required, Validators.min(1)]],
    });

    this.squareForm = this.fb.group({
      amount: ['', [Validators.required, Validators.min(1)]],
    });
    this.CashApp2Form = this.fb.group({
      amount: ['', [Validators.required, Validators.min(1)]],
    });
    this.squarecashForm = this.fb.group({
      amount: ['', [Validators.required, Validators.min(1)]],
    });
  }

  private destroy$ = new Subject<void>();
  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  closeKycPopup() {
    this.showKycPopup = false;
    // this.loaderService?.triggerWalletFunction();
    // this.router.navigate(['dashboard/wallet']);

    if (this.popupRedirect) {
      setTimeout(() => {
        this.router.navigate([this.popupRedirect]);
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();

    try {
      if (this.cashAppPay && typeof this.cashAppPay.destroy === 'function')
        this.cashAppPay.destroy();
    } catch (e) {
      /* ignore */
    }
  }
  @ViewChild('transactionTable', { static: false })
  transactionTable!: ElementRef;

  currentSearchTerm: string = '';

  onScroll(): void {
    const element = this.transactionTable.nativeElement;
    if (element.offsetHeight + element.scrollTop + 1 >= element.scrollHeight) {
      this.currentPage++;

      this.getWalletBalance(this.currentPage, this.currentSearchTerm);
    }
  }

  onMobileScroll(event: any) {
    const element = event.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      this.currentPage++;

      this.getWalletBalance(this.currentPage, this.currentSearchTerm);
    }
  }

  onScrollTop(): void { }

  onScrollBottom(): void { }

  dropdownOpen = false;
  selectedFilter = 'All Redeem';

  selectFilter(filter: string, event: Event) {
    event.preventDefault();
    this.selectedFilter = filter;
    this.dropdownOpen = false;

    //  console.log('Filter selected:', filter);
  }

  public totalBalance = 0;

  get privateValue(): number {
    return this.totalBalance;
  }
  transactions: any[] = [];
  Debittransactions: any[] = [];
  selectedTab: string = 'credit';
  searchControl: string = '';
  @Input() showModal = false;
  showwithdrawModal = false;
  newBalance = 0;
  email = '';

  showicon = faEye;
  hideicon = faEyeSlash;

  toggleData(bar: string) {
    this.selectedTab = bar;
  }

  WalletPayload() {
    return {
      customerId: Number(localStorage.getItem('customerId')),
      pageNumber: this.currentPage,
      pageSize: 10,
      searchText: this.currentSearchTerm || '',
      startDate: this.startDate || '',
      endDate: this.endDate || '',
    };
  }
  getWalletBalance(pageNumber: number = 1, searchText: string = '') {
    this.loaderService.show();
    const CustomerID = localStorage.getItem('customerId');
    // let payload = `Wallet/GetWalletBalance?CustomerId=${CustomerID}&PageNumber=${pageNumber}&PageSize=${10}`;
    let payload = this.WalletPayload();

    // if (searchText.trim()) {
    //   payload += `&SearchText=${encodeURIComponent(searchText.trim())}`;
    // }

    this.apiCallService
      .PostCallWithToken(payload, 'Wallet/GetWalletBalance')
      .subscribe(
        (response) => {
          if (response && response.responseCode == 200) {
            this.loaderService?.triggerWalletFunction();
            this.updateBalance(response.data.totalBalance);
            this.totalBalance =
              response.data.totalBalance === ''
                ? this.totalBalance
                : parseFloat(response.data.totalBalance);

            const creditTransactions = response.data.creditWallets.map(
              (transaction: any) => ({
                ...transaction,
                type: 'credit',
                balance: transaction.creditBalance,
                time: transaction.creditTime,
              })
            );

            const debitTransactions = response.data.debitWallets.map(
              (transaction: any) => ({
                ...transaction,
                type: 'debit',
                balance: transaction.debitAmount,
                time: transaction.debitDate,
              })
            );

            const newTransactions = [
              ...creditTransactions,
              ...debitTransactions,
            ].sort(
              (a, b) => new Date(b.time).getTime() - new Date(a.time).getTime()
            );

            if (pageNumber === 1) {
              this.transactions = newTransactions;
            } else {
              this.transactions = [...this.transactions, ...newTransactions];
            }

            this.loaderService.hide();
          } else {
            this.handleError.handleResponseError(response);
          }
        },
        (error) => {
          this.handleError.handleHttpError(error);
        }
      );
  }

  updateBalance(newBalance: number): void {
    this.GameService.balance = newBalance;
  }

  get filteredTransactions() {
    let allTransactions = this.transactions;

    switch (this.selectedFilter) {
      case 'Credited':
        allTransactions = allTransactions.filter(
          (transaction) => transaction.type === 'credit'
        );
        break;
      case 'Debited':
        allTransactions = allTransactions.filter(
          (transaction) => transaction.type === 'debit'
        );
        break;
      case 'All Redeem':
      default:
        break;
    }

    return allTransactions;
  }

  performSearch() {
    this.currentSearchTerm = this.searchControl;
    this.currentPage = 1; //
    this.getWalletBalance(1, this.currentSearchTerm);
  }

  onSearchInputChange(event: any) {
    if (event.key !== 'Enter') {
      if (!this.searchControl || this.searchControl.trim() === '') {
        this.clearSearch();
      }
    }
  }
  removeLeadingZero(event: any) {
    this.utilsService.removeLeadingZero(event);
  }

  clearSearch() {
    this.searchControl = '';
    this.currentSearchTerm = '';
    this.currentPage = 1;
    this.getWalletBalance(1, '');
  }
  card: any;
  cardSourceId: any;

  async ngOnInit() {
    // this.openAddBalanceModal();
    this.GetSquareAvilableAccount('Card');

    this.getActivePaymentMethods();

    // const payments = Square.payments(this?.SquareApiToken, this?.SquareProductId);
    // this.card = await payments.card();
    // await this.card.attach('#card-container');
  }
  // Square integration Start
  async initializeSquareCard() {
    const payments = Square.payments(this.SquareApiToken, this.SquareProductId);

    this.card = await payments.card({
      style: {
        input: {
          color: '#000000',
          fontSize: '16px'
        },
        'input::placeholder': {
          color: '#9aa0b4'
        },
        '.input-container': {
          borderColor: '#3a3f5a',
          borderRadius: '8px'
        },
        '.input-container.is-focus': {
          borderColor: '#7de7e5'
        },
        '.message-text': {
          color: '#ff4d4f'
        }
      }
    });

    await this.card.attach('#card-container');
  }
  // async initializeSquareCard() {
  //   if (!this.SquareApiToken || !this.SquareProductId) {
  //     console.error('Square keys missing');
  //     return;
  //   }

  //   const payments = Square.payments(this.SquareApiToken, this.SquareProductId);

  //   this.card = await payments.card();
  //   await this.card.attach('#card-container');
  // }
  // whopPayment('whop,card')
  async handlePaymentSquare() {
    // 1. Extract the amount from the form
    const amount = this.paymentFormSquare.get('amount')?.value;
    // 2. Basic check: Ensure the form is valid and amount is provided
    if (this.paymentFormSquare.invalid) {
      this.toastr.error('Please Fill All Fields', 'Form Error');
      return;
    }

    // 1. Locate the CashApp record from your data array
    const cardInfo = this.AccountType.find((account: any) => account.name === 'Card');
    if (cardInfo) {
      const min = cardInfo.MinDepositLimit;
      const max = cardInfo.MaxDepositLimit;
      // 2. Validate Minimum Limit
      if (amount < min) {
        this.loaderService.hide();
        this.toastr.warning(`Error: Min Deposit for Card is ${min}`, 'Invalid Amount');
        return
      }
      // 3. Validate Maximum Limit (only if MaxDepositLimit is greater than 0)
      if (max > 0 && amount > max) {
        this.loaderService.hide();
        this.toastr.warning(`Error: Max Deposit for Card is ${max}`, 'Invalid Amount');
        return
      }
    }

    this.loaderService.show();
    const result = await this.card.tokenize();
    if (result.status === 'OK') {
      //  console.log('Token created:', result.token);
      // this.cardSourceId = result.token;
      // Send result.token to your .NET Backend
      // this.sendTokenToBackend(result.token);
      this.loaderService.hide();
      this.PostSquarePayment(result.token);
    }
    else {
      this.loaderService.hide()
        ;
    }
  }
  PostSquarePayment(token: string) {
    // this.squareForm.markAllAsTouched();
    // if (this.squareForm.invalid) {
    //   this.loaderService.hide();
    //   return;
    // }
    this.loaderService.show();
    const formValue = this.paymentFormSquare.value;
    // const payload = {
    //   customerId: Number(localStorage.getItem('customerId')),
    //   amount: this.squareForm.value.amount,
    //   accountId: this.SquareAvailableAccounts?.Id,
    //   source: 'square,card',
    //   cardSourceId: token,
    // };
    const payload = {
      customerId: Number(localStorage.getItem('customerId')),
      amount: Number(formValue.amount),
      source: 'square,card',
      accountId: this.SquareAvailableAccounts?.Id,
      cardSourceId: token,
      email: localStorage.getItem('email') || '',
      addressLine1: formValue.streetAddress,
      city: formValue.city,
      zip: formValue.zip,
      state: formValue.state
    };

    this.apiCallService
      .PostCallWithToken(payload, 'SquarePayment/CreateSquarePayment')
      .subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            this.toastr.success(response.responseMessage, 'Success');
            this.squareForm.reset();
            this.loaderService.hide();
            this.hideWalletModal();
          } else {
            this.handleError.handleResponseError(response);
            this.loaderService.hide();
            this.hideWalletModal();
          }
        },
        error: (error) => {
          this.handleError.handleHttpError(error);
          this.loaderService.hide();
          this.hideWalletModal();
        },
      });
  }


  // Get Square account

  SquareAvailableAccounts: any;
  SquareApiToken: any = '';
  SquareProductId: any = '';

  GetSquareAvilableAccount(Accountname: string) {
    if (Accountname != 'Card') {
      return;
    }
    this.apiCallService
      .GetCallWithToken('SquarePayment/GetSquareAvilableAccount')
      .subscribe({
        next: async (response) => {
          if (response && response.responseCode === 200) {
            this.SquareAvailableAccounts = response.data[0];
            this.SquareApiToken = this.SquareAvailableAccounts?.ApiToken;
            this.SquareProductId = this.SquareAvailableAccounts?.ProductId;

            //  console.log('Square Accounts:', response.data);

            await this.initializeSquareCard();
          }
        },
        error: (error) => {
          this.handleError.handleHttpError(error);
        },
      });
  }
  // whopPayment('whop,cashapp')
  // Add this near the top of the class
  cashAppPayInitialized = false;
  // ...existing code...
  async initializeCashAppPay(amount: number) {
    // 1. Locate the CashApp record from your data array
    const cashAppInfo = this.AccountType.find((account: any) => account.name === 'CashApp1');
    if (cashAppInfo) {
      const min = cashAppInfo.MinDepositLimit;
      const max = cashAppInfo.MaxDepositLimit;
      // 2. Validate Minimum Limit
      if (amount < min) {
        this.loaderService.hide();
        this.toastr.warning(`Error: Min Deposit for CashApp is ${min}`, 'Invalid Amount');
        return
      }
      // 3. Validate Maximum Limit (only if MaxDepositLimit is greater than 0)
      if (max > 0 && amount > max) {
        this.loaderService.hide();
        this.toastr.warning(`Error: Max Deposit for CashApp is ${max}`, 'Invalid Amount');
        return
      }
    }

    this.loaderService.show();
    if (!this.SquareAvailableAccounts) {
      console.error('SquareAvailableAccounts not loaded');
      this.toastr.error('Configuration missing', 'Error');
      this.loaderService.hide();
      return;
    }

    // derive client-side values (inspect your backend response for exact field names)
    const applicationId =
      this.SquareAvailableAccounts?.ApplicationId ||
      this.SquareAvailableAccounts?.AppId ||
      this.SquareAvailableAccounts?.ClientApplicationId ||
      this.SquareApiToken; // fallback for debugging only (DO NOT use server secret in production)

    const locationId =
      this.SquareAvailableAccounts?.LocationId ||
      this.SquareAvailableAccounts?.ProductId ||
      this.SquareProductId;

    // console.log('Square init values:', { applicationId, locationId, envScriptLoaded: !!(window as any).Square });

    if (!applicationId || !locationId) {
      this.toastr.error(
        'Missing Application ID or Location ID for Square',
        'Configuration'
      );
      this.loaderService.hide();
      return;
    }

    try {
      // make sure SDK loaded
      if (!(window as any).Square) {
        throw new Error(
          'Square.js library not loaded. Use sandbox or production script in index.html'
        );
      }

      // use public applicationId and locationId
      this.payments = (window as any).Square.payments(
        applicationId,
        locationId
      );

      if (!this.payments) throw new Error('Square.payments() returned falsy');

      const paymentRequest = this.payments.paymentRequest({
        countryCode: 'US',
        currencyCode: 'USD',
        total: {
          amount: (amount || 0).toFixed(2),
          label: 'Total',
        },
      });

      // destroy previous instance if exists
      try {
        if (this.cashAppPay && typeof this.cashAppPay.destroy === 'function')
          this.cashAppPay.destroy();
      } catch (e) {
        /* ignore */
      }

      this.cashAppPay = await this.payments.cashAppPay(paymentRequest, {
        redirectURL: window.location.href,
        referenceId: `wallet-${Date.now()}`,
      });

      const container = document.getElementById('cash-app-pay-container');
      if (!container) throw new Error('cash-app-pay-container not found');
      this.loaderService.hide();
      await this.cashAppPay.attach('#cash-app-pay-container');
      this.cashAppPayInitialized = true;

      // Use addEventListener instead of .on()
      this.cashAppPay.addEventListener('ontokenization', (event: any) => {
        // Note: event.detail is where Square stores the result
        const tokenResult = event.detail.tokenResult;

        if (tokenResult.status === 'OK') {
          const token = tokenResult.token;
          // console.log('Cash App tokenization successful, token:', token);
          // this.handleCashAppToken(token); // Send to your .NET backend
          this.PostSquareCashAppPayment(token);
        } else {
          console.error('Cash App tokenization failed:', tokenResult.errors);
          this.toastr.error('Tokenization failed', 'Payment Error');
        }
      });
    } catch (err: any) {
      console.error(
        'Initializing Cash App Pay failed:',
        err,
        err?.errors || err?.detail
      );
      this.toastr.error(
        err?.message || 'Failed to initialize Cash App Pay',
        'Error'
      );
      this.loaderService.hide();
    }
  }
  // ...existing code...
  PostSquareCashAppPayment(token: string) {
    // this.squareForm.markAllAsTouched();
    // if (this.squareForm.invalid) {
    //   this.loaderService.hide();
    //   return;
    // }
    this.loaderService.show();
    const payload = {
      customerId: Number(localStorage.getItem('customerId')),
      amount: this.squareForm.value.amount,
      accountId: this.SquareAvailableAccounts?.Id,
      source: 'square,cashapp',
      cardSourceId: token,
    };
    this.apiCallService
      .PostCallWithToken(payload, 'SquarePayment/CreateSquarePayment')
      .subscribe({
        next: (response) => {
          ;
          if (response && response.responseCode === 200) {
            this.toastr.success(response.responseMessage, 'Success');
            this.squareForm.reset();
            this.loaderService.hide();
            this.hideWalletModal();
          } else {
            this.handleError.handleResponseError(response);
            this.loaderService.hide();
            this.hideWalletModal();
          }
        },
        error: (error) => {
          this.handleError.handleHttpError(error);
          this.loaderService.hide();
          this.hideWalletModal();
        },
      });
  }
  // Square integration end
  openAddBalanceModal() {
    this.showModal = true;
    this.showcard = true;
    this.paymentForm.reset();
    this.showcashApp = false;
    this.showChimeZelle = false;
    this.cashappForm.reset();
    this.getAccountsDropdown();
    this.newBalance = 0;
    this.email = ''
    this.selectedAccount = 'Manual';
    this.selectedAccounttitle = '';
    this.selectedAccountType = 'Card';
  }

  getCustomerID(): number | null {
    return Number(localStorage.getItem('customerId'));
  }
  getToken(): string | null {
    return localStorage.getItem('token');
  }
  getUsername(): string | null {
    return localStorage.getItem('userName');
  }
  addBalance() {
    if (this.newBalance > 0 && this.newBalance >= 5 && this.newBalance <= 300) {
      if (this.isShowManualEntry) {
        this.addWalletRequest();
      }
      else {
        this.loaderService.show();

        const apiurl = `Wallet/CreateCoralPayment?Payment=${this.newBalance
          }&Username=${this.getUsername()}`;

        // Open a new blank tab immediately to prevent browser pop-up blockers
        const newTab = window.open('', '_blank');

        this.apiCallService.GetCallWithToken(apiurl).subscribe({
          next: (response) => {
            if (response && response.responseCode === 200) {
              this.toastr.success(response.responseMessage, 'Success');
              if (newTab) {
                newTab.location.href = response.data.purchaseURL; // Redirect the blank tab
              } else {
                window.open(response.data.purchaseURL, '_blank'); // Fallback in case tab is blocked
              }
            } else {
              this.handleError.handleResponseError(response);
              if (newTab) newTab.close(); // Close the tab if API fails
            }
            this.loaderService.hide();
            this.hideWalletModal();
          },
          error: (error) => {
            this.handleError.handleHttpError(error);
            if (newTab) newTab.close(); // Close the tab on error
            this.loaderService.hide();
            this.hideWalletModal();
          },
        });
      }
    } else {
      this.toastr.info('Amount must be within 5 to 300', 'Invalid Amount');
    }
  }
  showBalance: boolean = false;

  addWalletRequestPayload() {
    return {
      customerId: this.getCustomerID(),
      balance: this.newBalance || 0,
      email: this.email || '',
      type: 'Credit',
      status: 'Pending',
      source: this.selectedAccount || '',
      accountTitle: this.selectedAccounttitle || '',
      imageUrl: this.uploadProfileImage || '',
      accountInfo: this.CustomerTag || '',
    };
  }
  addWalletRequest() {
    this.loaderService.show();
    // 1. Find the selected account details from the AccountType list
    const selectedAccountDetails = this.AccountType.find(
      (account: any) => account.name === this.selectedAccount
    );

    if (selectedAccountDetails) {
      const amount = this.newBalance || 0;
      const min = selectedAccountDetails.MinDepositLimit;
      const max = selectedAccountDetails.MaxDepositLimit;

      // 2. Perform the limit checks
      if (amount < min) {
        this.toastr.warning(`Error: Min Deposit for ${this.selectedAccount} is ${min}`, 'Invalid Amount');
        this.loaderService.hide();
        return
      }

      if (max > 0 && amount > max) {
        this.toastr.warning(`Error: Max Deposit for ${this.selectedAccount} is ${max}`, 'Invalid Amount');
        this.loaderService.hide();
        return
      }
    }

    const payload = this.addWalletRequestPayload();
    if (
      payload.imageUrl != '' &&
      payload.source != '' &&
      payload.accountTitle != '' &&
      payload.email != ''
    ) {
      // this.loaderService.show();
      this.apiCallService
        .PostCallWithToken(payload, 'Wallet/CreateWalletPaymentRequest')
        .subscribe({
          next: (response) => {
            if (response && response.responseCode === 200) {
              this.toastr.success(response.responseMessage, 'Success');
              this.getWalletBalance();
              this.loaderService.hide();
              this.hideWalletModal();
            } else {
              this.handleError.handleResponseError(response);
              // this.loaderService.hide();
              this.hideWalletModal();
            }
          },
          error: (error) => {
            this.handleError.handleHttpError(error);
            // this.loaderService.hide();
            this.hideWalletModal();
          },
        });
    } else {
      this.toastr.info(
        'Please Select Account Details, Upload image and Add Email',
        'Validation'
      );
      this.loaderService.hide();
    }
  }

  // filter section

  currentPage: number = 1;

  // TS Code for Pagination End
  isAccountSelected: boolean = false;
  isShowManualEntry: boolean = true;
  onAccountChange(selectedValue: any): void {
    this.selectedAccounttitle = '';
    this.isAccountSelected = true;
  }
  onAccountTypesChange(selectedValue: string): void {
    this.selectedAccountType = selectedValue;
  }

  accountDropdownOpen = false;
  selectedAccount: string = '';
  selectAccount(account: any, event: Event) {
    event.preventDefault();
    this.selectedAccount = account?.name || '';
    this.accountDropdownOpen = false;
    this.onAccountChange(account || '');
  }
  selectAccountTypes(name: string, event: Event) {
    event.preventDefault();
    this.selectedAccountType = name;
    if (name == 'Manual') {
      this.accountDropdownOpen = true;
    }
    // this.onAccountChange(name);
  }

  @HostListener('document:click')
  closeDropdown() {
    this.accountDropdownOpen = false;
  }

  toggleManualEntry() {
    this.isShowManualEntry = !this.isShowManualEntry;
  }
  manualEntry(event: Event) {
    event.stopPropagation();
    this.isShowManualEntry = true;
    this.selectedAccountType = '';
    this.selectedAccounttitle = '';
    this.uploadProfileImage = '';
  }

  autoEntry(event: Event) {
    event.stopPropagation();
    this.isShowManualEntry = false;
  }

  selectedAccountType: string = '';
  selectedAccounttitle: string = '';
  PaypalAccounts: any;
  ChimeAccounts: any;
  ZelleAccounts: any;
  // api/

  manualAccounts: any = [];
  getAccountsDropdown() {
    this.apiCallService
      .GetCallWithToken('CashTag/GetAccountsDropdown')
      .subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            // this.ChimeAccounts = response.data.chime;
            // this.CashtagAccounts = response.data.cashApp;
            this.manualAccounts = Object.keys(response.data).map((key) => ({
              name: key,
              accounts: response.data[key],
            }));
            this.ChimeAccounts =
              response.data.chime.length > 0
                ? response.data.chime
                : [{ accountDetail: 'No data found' }];
            this.PaypalAccounts =
              response.data.cashApp.length > 0
                ? response.data.payalApp
                : [{ accountDetail: 'No data found' }];
            this.ZelleAccounts =
              response.data.zelle.length > 0
                ? response.data.zelle
                : [{ accountDetail: 'No data found' }];
          } else {
            // this.handleError.handleResponseError(response);
            // this.hideWalletModal();

            this.ChimeAccounts = [{ accountDetail: 'No data found' }];
            this.PaypalAccounts = [{ accountDetail: 'No data found' }];
            this.ZelleAccounts = [{ accountDetail: 'No data found' }];
          }
        },
        error: (error) => {
          // this.handleError.handleHttpError(error);
          // this.hideWalletModal();
        },
      });
  }

  AccountType: any = [];
  // real
  // getActivePaymentMethods() {
  //   this.loaderService.show();
  //   this.apiCallService
  //     .GetCallWithToken('PaymentMethod/GetAllActivePaymentMethods')
  //     .subscribe(
  //       (res) => {
  //         if (res && res.responseCode == 200) {
  //           this.AccountType = res.data.map((accType: any) => {
  //             const matchedType = this.getAccount(accType);
  //             //  ;
  //             return {
  //               id: accType.Id,
  //               name: matchedType?.name || accType.Value,
  //               isActive: accType.IsActive,
  //               Bonus: accType.Bonus,
  //               bg_image: matchedType?.bg_image,
  //               kycStatus: accType.kycStatus,
  //             };
  //           });
  //           this.loadFirstPaymentMethod();
  //           console.log('Active Payment Methods:', this.AccountType);
  //         } else {
  //           this.AccountType = [];
  //           this.handleError.handleResponseError(res);
  //         }
  //         this.loaderService.hide();
  //       },
  //       (error) => {
  //         this.handleError.handleHttpError(error);
  //         this.loaderService.hide();
  //       }
  //     );
  // }

  // Sorting
  //   getActivePaymentMethods() {
  //   this.loaderService.show();
  //   this.apiCallService
  //     .GetCallWithToken('PaymentMethod/GetAllActivePaymentMethods')
  //     .subscribe(
  //       (res) => {
  //         if (res && res.responseCode == 200) {
  //           // 1. Map the data as you were doing
  //           const mappedData = res.data.map((accType: any) => {
  //             const matchedType = this.getAccount(accType);
  //             return {
  //               id: accType.Id,
  //               name: matchedType?.name || accType.Value,
  //               isActive: accType.IsActive,
  //               Bonus: accType.Bonus,
  //               bg_image: matchedType?.bg_image,
  //               kycStatus: accType.kycStatus,
  //               MinDepositLimit: accType.MinDepositLimit,
  //               MaxDepositLimit: accType.MaxDepositLimit
  //             };
  //           });

  //           // 2. Sort the array so CashApp is always at the end
  //           this.AccountType = mappedData.sort((a: any, b: any) => {
  //             const isACashApp = a.name.toLowerCase().includes('cashapp');
  //             const isBCashApp = b.name.toLowerCase().includes('cashapp');

  //             if (isACashApp && !isBCashApp) return 1;  // Move 'a' (CashApp) to the end
  //             if (!isACashApp && isBCashApp) return -1; // Keep 'b' (CashApp) at the end
  //             return 0; // Maintain original order for everything else
  //           });

  //           this.loadFirstPaymentMethod();
  //           console.log('Sorted Payment Methods:', this.AccountType);
  //         } else {
  //           this.AccountType = [];
  //           this.handleError.handleResponseError(res);
  //         }
  //         this.loaderService.hide();
  //       },
  //       (error) => {
  //         this.handleError.handleHttpError(error);
  //         this.loaderService.hide();
  //       }
  //     );
  // }

  getActivePaymentMethods() {
    this.loaderService.show();
    this.apiCallService
      .GetCallWithToken('PaymentMethod/GetAllActivePaymentMethods')
      .subscribe(
        (res) => {
          if (res && res.responseCode == 200) {
            // 1. Map the data and then Filter immediately
            this.AccountType = res.data
              .map((accType: any) => {
                const matchedType = this.getAccount(accType);
                return {
                  id: accType.Id,
                  name: matchedType?.name || accType.Value,
                  isActive: accType.IsActive,
                  Bonus: accType.Bonus,
                  bg_image: matchedType?.bg_image,
                  kycStatus: accType.kycStatus,
                  MinDepositLimit: accType.MinDepositLimit,
                  MaxDepositLimit: accType.MaxDepositLimit
                };
              })
              // 2. Only keep items where isActive is true
              .filter((acc: any) => acc.isActive === true || acc.isActive === 1);

            this.loadFirstPaymentMethod();
            console.log('Filtered Active Payment Methods:', this.AccountType);
          } else {
            this.AccountType = [];
            this.handleError.handleResponseError(res);
          }
          this.loaderService.hide();
        },
        (error) => {
          this.handleError.handleHttpError(error);
          this.loaderService.hide();
        }
      );
  }

  getAccount(acc: any) {
    const types = paymentTypes;
    const match = Object.values(types).find(
      (type: any) => type.ApiName.toLowerCase() === acc.Value.toLowerCase()
    );
    return match;
  }

  loadFirstPaymentMethod() {
    const FirstMethod = this.AccountType[0];
    // this.selectedAccountType = FirstMethod.name;
    // this.togglePayment(
    //   FirstMethod.name,
    //   FirstMethod.isActive,
    //   FirstMethod.kycStatus
    // );
  }
  accountsTitle: any;
  accountTitleDropdownOpen = false;
  showPayPalFields: boolean = false;
  payPalDetails: any;
  CustomerTag: any = '';
  qrCodeImage: string = '';
  selectAccountTitle(accountDetail: any) {
    this.qrCodeImage = '';
    this.selectedAccounttitle = accountDetail.AccountTitle;
    this.accountTitleDropdownOpen = false;

    if (this.selectedAccountType == 'Paypal') {

      this.showPayPalFields = true;
      this.payPalDetails = accountDetail;
      this.qrCodeImage = accountDetail.ImageUrl;
    } else if (this.selectedAccountType == 'Chime') {
      this.CustomerTag = accountDetail.CustomerTag;
      this.qrCodeImage = accountDetail.ImageUrl;
      this.showPayPalFields = false;
      this.payPalDetails = null;
    } else if (this.selectedAccountType == 'Venmo') {
      this.CustomerTag = accountDetail.CustomerTag;
      this.qrCodeImage = accountDetail.ImageUrl;
      this.showPayPalFields = false;
      this.payPalDetails = null;
    } else if (this.selectedAccountType == 'Zelle') {
      this.CustomerTag = accountDetail.CustomerTag;
      this.qrCodeImage = accountDetail.ImageUrl;
      this.showPayPalFields = false;
      this.payPalDetails = null;
    } else {
      this.showPayPalFields = false;
      this.payPalDetails = null;
      this.qrCodeImage = accountDetail.ImageUrl;
    }
  }

  // uploadProfileImage: string = '';
  // async onFileSelected(event: Event) {
  //   const file = (event.target as HTMLInputElement)?.files?.[0];

  //   if (file) {
  //     try {
  //       //? Show loader while processing
  //       this.loaderService.show();

  //       //? Convert the file to a base64 string
  //       const base64Image = await this.convertFileToBase64(file);

  //       //? Create the API payload
  //       const payload: any = {
  //         base64Image: base64Image,
  //       };
  //       this.uploadProfileImage = base64Image;
  //       this.loaderService.hide();
  //     } catch {}
  //   }
  // }
  // private convertFileToBase64(file: File): Promise<string> {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onload = () => resolve(reader.result as string);
  //     reader.onerror = (error) => reject(error);
  //     reader.readAsDataURL(file);
  //   });
  // }


  uploadProfileImage: string = '';
  async onFileSelected(event: Event) {
    const file = (event.target as HTMLInputElement)?.files?.[0];

    if (file) {
      try {
        this.loaderService.show();

        const base64Image = await this.convertFileToBase64(file);

        const payload: any = {
          base64Image: base64Image,
        };

        this.uploadProfileImage = base64Image;

        this.loaderService.hide();
      } catch (error) {
        this.loaderService.hide();
        console.error(error);
      }
    }
  }


  private convertFileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        const img = new Image();

        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          canvas.width = img.width;
          canvas.height = img.height;

          ctx?.drawImage(img, 0, 0);

          const compressedBase64 = canvas.toDataURL('image/jpeg', 0.6);

          // LOGS HERE
          console.log(
            'Original Size:',
            (file.size / 1024).toFixed(2),
            'KB'
          );

          console.log(
            'Compressed Size:',
            ((compressedBase64.length * 3) / 4 / 1024).toFixed(2),
            'KB'
          );

          resolve(compressedBase64);
        };

        img.onerror = reject;
        img.src = e.target.result;
      };

      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }
  clearSelection() {
    this.uploadProfileImage = '';
  }
  hideWalletModal() {
    this.showModal = false;
    this.handleError.showModalSubject.next(false);
    // this.isShowManualEntry = false;
    this.uploadProfileImage = '';
    this.selectedAccount = '';
    this.selectedAccounttitle = '';
  }

  accountTypeDropdownOpen = false;
  sourceAccount: string = '';
  isAccountTypeSelected: boolean = false;

  selectAccountType(name: string, event: Event) {
    event.stopPropagation();
    this.sourceAccount = name;
    this.accountTypeDropdownOpen = false;
    this.onAccountTypeChange({ target: { value: name } } as any);
  }

  onAccountTypeChange(event: Event) {
    this.isAccountTypeSelected = true;
    this.sourceAccount = (event.target as HTMLSelectElement).value;
  }
  accountTypeData: any = [
    {
      id: 1,
      name: 'CashApp',
    },
    {
      id: 2,
      name: 'Chime',
    },
    {
      id: 3,
      name: 'Zelle',
    },
    // {
    //   id: 4,
    //   name: 'Transic (payment link)',
    // },
  ];

  amouttowithdraw: number = 0;
  accountInfo: string = '';

  // Authorize.Net Payment Integration Start
  payCard() {
    this.loaderService.show();
    if (this.paymentForm.invalid) {
      this.paymentForm.markAllAsTouched();
      this.loaderService.hide();
      return;
    }

    // 1. Card account ki details nikalen
    const cardDetails = this.AccountType.find((account: any) => account.name === 'Card');
    const amount = Number(this.paymentForm.value.amount) || 0;

    if (cardDetails) {
      const min = cardDetails.MinDepositLimit;
      const max = cardDetails.MaxDepositLimit;

      // 2. Min limit check
      if (amount < min) {
        this.toastr.warning(`Error: Min Deposit for Card is ${min}`, 'Invalid Amount');
        this.loaderService.hide();
        return;
      }

      // 3. Max limit check
      if (max > 0 && amount > max) {
        this.toastr.warning(`Error: Max Deposit for Card is ${max}`, 'Invalid Amount');
        this.loaderService.hide();
        return;
      }
    }


    const apiurl = `CashAppPayment/GetAuthorizeAccountInfo?Amount=${this.paymentForm.value.amount}&Source=AuthorizeNet`;
    this.apiCallService.GetCallWithToken(apiurl).subscribe({
      next: (response) => {
        if (response && response.responseCode === 200) {
          this.loaderService.hide();
          this.pay(
            response.data.clientKey,
            response.data.apiLoginID,
            response.data.id
          );
        } else {
          this.handleError.handleResponseError(response);
          this.loaderService.hide();
        }
      },
      error: (error) => {
        this.handleError.handleHttpError(error);
        this.loaderService.hide();
      },
    });
  }
  async pay(clientKey?: string, apiLoginID?: string, accountid?: number) {
    this.loaderService.show();
    // if (this.paymentForm.invalid) {
    //   this.paymentForm.markAllAsTouched();
    //   this.loaderService.hide();
    //   return;
    // }

    try {
      const formValue = this.paymentForm.value;
      const cardData = {
        cardNumber: formValue.cardNumber.toString(),
        month: formValue.month.toString(),
        year: formValue.year.toString().slice(-2),
        cardCode: formValue.cvv.toString(),
      };
      // These come from Authorize.Net merchant account (client key + login ID)
      // const authData = {
      //   clientKey: '8CRkkTs9N2M69SY6p6XMen7mk5xKP4khDmVwu2jTun93F3rK7VTqyq3kGZybTBC9',
      //   apiLoginID: '2aUJ4fF7U'
      // };
      // Form se naye fields extract karein
      const billingData = {
        firstName: formValue.firstName || '',
        lastName: formValue.lastName || '',
        address: formValue.address || '',
        city: formValue.city || '',
        state: formValue.state || '',
        country: formValue.country || 'US',
        phoneNumber: formValue.phoneNumber || '',
        email: formValue.email || '',
        zipCode: formValue.zipCode?.toString() || ''
      };

      const authData = {
        clientKey: clientKey,
        apiLoginID: apiLoginID,
      };

      const opaqueData = await this.getPaymentNonce(
        cardData,
        authData,
        accountid,
        billingData
      );
      // console.log('Opaque Data Genrated:', opaqueData);
    } catch (err) {
      console.error('Error generating token:', err);
      this.loaderService.hide();
    }
  }

  opaquePayload: any;
  getPaymentNonce(cardData: any, authData: any, accountid: any, billingData: any): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!(window as any).Accept) {
        console.error('Authorize.Net Accept.js library not loaded.');
        this.loaderService.hide();
        return;
      }
      // Accept.js ke standard format me billingData pass kiya
      const acceptBillingData = {
        firstName: billingData.firstName,
        lastName: billingData.lastName,
        address: billingData.address,
        city: billingData.city,
        state: billingData.state,
        zip: billingData.zipCode, // Accept.js expects 'zip' keyword internally
        country: billingData.country
      };

      (window as any).Accept.dispatchData(
        {
          authData,
          cardData,
          billingData: acceptBillingData
        },
        (response: any) => {
          if (response.messages.resultCode === 'Error') {
            reject(response.messages.message[0].text);
            this.loaderService.hide();
          } else {
            resolve(response.opaqueData);
            // this.opaquePayload = { opaqueData: response.opaqueData };
            this.opaquePayload = {
              customerId: Number(localStorage.getItem('customerId')),
              amount: this.paymentForm.value.amount,
              source: 'AuthorizeNet',
              accountId: accountid,
              opaqueData: {
                dataDescriptor: response.opaqueData.dataDescriptor,
                dataValue: response.opaqueData.dataValue,
              },
              billingDetails: {
                firstName: billingData.firstName,
                lastName: billingData.lastName,
                address: billingData.address,
                city: billingData.city,
                state: billingData.state,
                country: billingData.country,
                phoneNumber: billingData.phoneNumber,
                email: billingData.email,
                zipCode: billingData.zipCode
              }
            };

            // console.log('Payment nonce (opaqueData):', this.opaquePayload);
            this.sendDatatoApi();
          }
        }
      );
    });
  }

  sendDatatoApi() {
    this.apiCallService
      .PostCallWithToken(
        this.opaquePayload,
        'CashAppPayment/AuthorizeCardPaymentProcessor'
      )
      .subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            this.toastr.success(response.responseMessage, 'Success');
            this.paymentForm.reset();
            this.loaderService.hide();
          } else {
            this.handleError.handleResponseError(response);
            this.loaderService.hide();
          }
        },
        error: (error) => {
          this.handleError.handleHttpError(error);
          this.loaderService.hide();
        },
      });
  }
  // Authorize.Net Payment Integration End

  // Stripe Cash App Payment Integration Start
  getCustomerId(): string | null {
    return localStorage.getItem('customerId');
  }
  paycashApp() {
    this.loaderService.show();

    if (this.cashappForm.invalid) {
      this.cashappForm.markAllAsTouched();
      this.loaderService.hide();
      return;
    }
    // Open a new blank tab immediately to prevent browser pop-up blockers
    const newTab = window.open('', '_blank');
    // const amount = this.cashappForm.get('amount')?.value;
    const amount = this.cashappForm.get('amount')?.value * 100;
    const customerId = this.getCustomerId();
    const posturl = `PaymentIntent/CreatePaymentIntent?amount=${amount}&CustomerId=${customerId}&Source=stripe,cashapp`;

    this.apiCallService.PostCallWithToken(null, posturl).subscribe({
      next: (response) => {
        if (response && response.responseCode === 200) {
          this.toastr.success(response.responseMessage, 'Success');
          if (newTab) {
            newTab.location.href = response.data.mobile_auth_url; // Redirect the blank tab
          } else {
            window.open(response.data.mobile_auth_url, '_blank'); // Fallback in case tab is blocked
          }
        } else {
          this.handleError.handleResponseError(response);
          if (newTab) newTab.close(); // Close the tab if API fails
        }
        this.loaderService.hide();
        this.hideWalletModal();
      },
      error: (error) => {
        this.handleError.handleHttpError(error);
        if (newTab) newTab.close(); // Close the tab on error
        this.loaderService.hide();
        this.hideWalletModal();
      },
    });
  }
  // Stripe cash app integration end

  // KYC for NotSubmited Popup Texts

  popupTitle = '';
  popupMessage = '';
  popupButtonText = '';
  popupRedirect: string | null = null;

  Ntitlekyc: string = 'KYC Required';
  Nmessagekyc: string = 'Please complete KYC Form for Payments.';
  Nbuttontextkyc: string = 'KYC Form';
  NredirecttoKYCform: string = '/dashboard/KYCform';
  // KYC for pending Popup Texts
  ptitlekyc: string = 'KYC Verification';
  pmessagekyc: string =
    'Your verification is currently in process. Please wait while we complete the review.';
  pbuttontextkyc: string = 'Got it';

  // toogles payment buttons
  showSquare: boolean = false;
  togglePayment(
    name: string,
    active?: boolean,
    kycCompleted?: boolean,
    event?: Event
  ) {
    if (kycCompleted === true) {
      const kyc = localStorage.getItem('KYC');
      if (kyc === 'Pending') {
        this.popupTitle = this.ptitlekyc;
        this.popupMessage = this.pmessagekyc;
        this.popupButtonText = this.pbuttontextkyc;
        this.popupRedirect = null;
        this.showKycPopup = true;

        return;
      } else if (kyc === 'Not Submitted') {
        this.popupTitle = this.Ntitlekyc;
        this.popupMessage = this.Nmessagekyc;
        this.popupButtonText = this.Nbuttontextkyc;
        this.popupRedirect = this.NredirecttoKYCform;
        this.showKycPopup = true;

        return;
      }
    }
    if (active === false) {
      return;
    } else {
      this.qrCodeImage = '';
      this.selectedAccountType = name;
      if (event) {
        event.preventDefault();
      }
      if (name == 'Card') {
        this.showcardForm();
      }
      else if (name == 'CashApp1') {
        this.showcashAppForm();
        this.cashAppPayInitialized = false;
        try {
          if (this.cashAppPay && typeof this.cashAppPay.destroy === 'function')
            this.cashAppPay.destroy();
        } catch (e) {
          /* ignore */
        }
      }
      else if (name == 'Chime') {
        this.showChimeZelleForm();
        this.selectedAccount = 'Chime';
        // this.accountsTitle = this.ChimeAccounts;
        this.loadDropDownValues();
      }
      else if (name == 'Zelle') {
        this.showChimeZelleForm();
        this.selectedAccount = 'Zelle';
        // this.accountsTitle = this.ZelleAccounts;
        this.loadDropDownValues();
      }
      else if (name == 'Paypal') {
        this.showChimeZelleForm();
        this.selectedAccount = 'Paypal';
        this.loadDropDownValues();
      }
      else if (name == 'Venmo') {
        this.showChimeZelleForm();
        this.selectedAccount = 'Venmo';
        this.loadDropDownValues();
      }
      else if (name == 'GooglePay') {
        // this.showChimeZelleForm();
        this.newBalance = 0;
        this.email = ''
        this.showChimeZelle = false;
        this.showcashApp = false;
        this.showcard = false
        this.selectedAccount = 'GooglePay';
        this.loadDropDownValues();
      }
      else if (name == 'ApplePay') {
        // this.showChimeZelleForm();
        this.newBalance = 0;
        this.email = ''
        this.showChimeZelle = false;
        this.showcashApp = false;
        this.showcard = false;
        this.selectedAccount = 'ApplePay';
        this.loadDropDownValues();
      }
      else if (name == 'Card2') {
        this.showChimeZelleForm();
        this.newBalance = 0;
        this.email = ''
        // this.showChimeZelle=false;
        // this.showcashApp=false;
        // this.showcard=false
        this.selectedAccount = 'Card2';
        this.loadDropDownValues();
      }
      else if (name == 'CashApp2') {
        // this.showChimeZelleForm();
        this.newBalance = 0;
        this.email = ''
        this.showChimeZelle = false;
        this.showcashApp = false;
        this.showcard = false
        this.selectedAccount = 'CashApp2';
        this.loadDropDownValues();
      }
      else {
        return;
      }
    }
  }

  showcard: boolean = false;
  showcardForm() {
    this.showSquare = true;
    this.showcard = true;
    this.showcashApp = false;
    this.showChimeZelle = false;
    this.stripeCardUi = false;
    this.StripeCardAccountID = '';
    this.StripeCardPublishKey = '';
    this.StripeCardSecret = '';
  }
  showcashApp: boolean = false;
  showcashAppForm() {
    this.showcashApp = true;
    this.showcard = false;
    this.showChimeZelle = false;
  }
  showChimeZelle: boolean = false;
  showChimeZelleForm() {
    this.newBalance = 0;
    this.email = ''
    this.selectedAccounttitle = '';
    this.showChimeZelle = true;
    this.showcashApp = false;
    this.showcard = false;
  }

  loadDropDownValues() {
    this.accountsTitle = [];
    const paylaod = {
      paymentName: this.selectedAccountType,
    };
    this.loaderService.show();
    this.apiCallService
      .PostCallWithToken(paylaod, 'PaymentMethod/GetManuallPaymentsAccountInfo')
      .subscribe(
        (res) => {
          if (res && res.responseCode == 200) {
            this.loaderService.hide();
            if (this.selectedAccountType == 'Paypal') {
              this.accountsTitle = res.data.map((acc: any) => ({
                id: acc.id,
                Value: acc.Value,
                Email: acc.Email,
                AccountTitle: acc.AccTitle,
                Link: acc.Link,
                Bonus: acc.Bonus,
                ImageUrl: acc.ImageUrl,
              }));
            } else {
              this.accountsTitle = res.data;
            }
          } else {
            this.handleError.handleResponseError(res);
          }
          this.loaderService.hide();
        },
        (error) => {
          this.handleError.handleHttpError(error);
          this.loaderService.hide();
        }
      );
  }

  isCopied = signal(false);
  CopyToClipBoard(text: string) {
    if (text != '') {
      navigator.clipboard.writeText(text);
      this.isCopied.set(true);
      setTimeout(() => {
        this.isCopied.set(false);
      }, 2000);
    }
  }

  RedirectToLink(link: string) {
    window.open(link, '_blank');
  }



  // Post call to Square Payment API

  //   {
  //   "customerId": 0,
  //   "amount": 0,
  //   "source": "string",
  //   "accountId": 0,
  //   "cardSourceId": "string"
  // }

  // Whop payment integration start

  whopPayment(token: string) {
    this.squareForm.markAllAsTouched();
    if (this.squareForm.invalid) {
      this.loaderService.hide();
      return;
    }
    this.loaderService.show();
    const payload = {
      payment: this.squareForm.value.amount?.toString(),
      source: token,
    };
    this.apiCallService
      .PostCallWithToken(payload, 'whop/webhook/CreateWhopPayment')
      .subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            const newTab = window.open('', '_blank');
            this.toastr.success(response.responseMessage, 'Success');
            this.squareForm.reset();
            this.loaderService.hide();
            if (newTab) {
              newTab.location.href = response.data?.purchaseURL; // Redirect the blank tab
            } else {
              window.open(response.data?.purchaseURL, '_blank'); // Fallback in case tab is blocked
            }
            this.hideWalletModal();
          } else {
            this.handleError.handleResponseError(response);
            this.loaderService.hide();
            this.hideWalletModal();
          }
        },
        error: (error) => {
          this.handleError.handleHttpError(error);
          this.loaderService.hide();
          this.hideWalletModal();
        },
      });
  }

  // whop payment integration end


  // Stripe Card Payment Integration Start
  stripeCardUi: boolean = false;
  StripeCardAccountID: any
  StripeCardPublishKey: any
  StripeCardSecret: any
  StripeCardPaymentIntentId: any

  createStripeCardPayment() {

    this.squareForm.markAllAsTouched();
    if (this.squareForm.invalid) {
      this.loaderService.hide();
      return;
    }
    this.loaderService.show();
    const payload = {
      customerId: Number(localStorage.getItem('customerId')),
      amount: this.squareForm.value.amount,
      source: 'stripe,card',
      accountId: 0,
      cardSourceId: ''
    }
    this.apiCallService
      .PostCallWithToken(
        payload,
        'PaymentIntent/CreateStripeCardPayment'
      )
      .subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            this.toastr.success(response.responseMessage, 'Success');
            // this.paymentForm.reset();
            this.StripeCardAccountID = response?.data?.accountid;
            this.StripeCardPublishKey = response?.data?.publishKey;
            this.StripeCardSecret = response?.data?.clientSecret;
            this.StripeCardPaymentIntentId = response?.data?.paymentIntentId;
            this.loadCardUiStripe();
            this.stripeCardUi = true;
            this.loaderService.hide();
          } else {
            this.handleError.handleResponseError(response);
            this.loaderService.hide();
          }
        },
        error: (error) => {
          this.handleError.handleHttpError(error);
          this.loaderService.hide();
        },
      });
  }

  async loadCardUiStripe() {
    this.stripe = await loadStripe(this.StripeCardPublishKey);
    // Check if stripe initialized successfully
    if (this.stripe) {
      this.elements = this.stripe.elements();
      // Create and mount the card
      this.card = this.elements.create('card');
      this.card.mount('#card-element');
      this.loaderService.hide();
    } else {
      console.error('Stripe failed to load');
      this.loaderService.hide();
    }
  }


  async stripeCardAuthenticate() {
    this.loaderService.show();
    const clientSecret = this.StripeCardSecret.toString();

    const result = await this.stripe!.confirmCardPayment(clientSecret, {
      payment_method: {
        card: this.card
      }
    });

    if (result.error) {
      this.toastr.warning(result.error.message, 'Warning');
      this.loaderService.hide();
    } else if (result.paymentIntent && result.paymentIntent.status === 'succeeded') {
      // alert("Payment Successful!");
      this.verifyStripeCardPayment();
      this.loaderService.hide();
    }
  }

  verifyStripeCardPayment() {
    this.loaderService.show();
    this.apiCallService
      .PostCallWithToken(null, `PaymentIntent/VerifyStripeCardPayment?accountid=${this.StripeCardAccountID}&intentid=${this.StripeCardPaymentIntentId}`).subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            this.toastr.success(response.responseMessage, 'Success');
            this.showcardForm();
            this.hideWalletModal();
            this.loaderService.hide();
          } else {
            this.handleError.handleResponseError(response);
            this.loaderService.hide();
          }
        },
        error: (error) => {
          this.handleError.handleHttpError(error);
          this.loaderService.hide();
        },
      });

  }

  // Stripe Card Payment Integration End

  showQrPopup = false;

  openQrPopup(): void {
    this.showQrPopup = true;
  }

  closeQrPopup(): void {
    this.showQrPopup = false;
  }


  // Google and Apple pay and casapp link pay
  getPaymentLink(): string {
    if (this.newBalance >= 10) {
      return 'https://taptapup.com/cashme/bill-mate-ultra/';
    } else if (this.newBalance >= 5 && this.newBalance <= 9) {
      return 'https://taptapup.com/cashme/bill-mate-777';
    }
    return '';
  }

  amountOptions: number[] = [9.99, 14.99, 17.99, 19.99, 24.99, 29.99, 30.99, 39.99, 49.99, 59.99, 99.99]
  // .map(amt => Math.floor(amt));

  AddAppleGooglePayPayload() {
    return {
      customerId: this.getCustomerID(),
      balance: this.newBalance || 0,
      email: this.email || '',
      type: 'Credit',
      status: 'Pending',
      source: this.selectedAccount || '',
      accountTitle: '',
      imageUrl: this.uploadProfileImage || '',
      accountInfo: '',
    };
  }



  AddAppleGoogleCashApp2Pay() {
    const payload = this.AddAppleGooglePayPayload();
    //  if (!payload.balance || payload.balance < 5 || payload.balance > 300) {
    //   this.toastr.info('Amount must be within 5 to 300', 'Invalid Amount');
    //     return; 
    // }
    // 1. Find the selected account details from the AccountType list
    const selectedAccountDetails = this.AccountType.find(
      (account: any) => account.name === this.selectedAccount
    );

    if (selectedAccountDetails) {
      const amount = this.newBalance || 0;
      const min = selectedAccountDetails.MinDepositLimit;
      const max = selectedAccountDetails.MaxDepositLimit;

      // 2. Perform the limit checks
      if (amount < min) {
        this.toastr.warning(`Error: Min Deposit for ${this.selectedAccount} is ${min}`, 'Invalid Amount');
        this.loaderService.hide();
        return
      }

      if (max > 0 && amount > max) {
        this.toastr.warning(`Error: Max Deposit for ${this.selectedAccount} is ${max}`, 'Invalid Amount');
        this.loaderService.hide();
        return
      }
    }

    if (payload.source === 'CashApp2') {
      payload.source = 'TapTap,CashApp';
    }
    if (payload.source === 'Card2') {
      payload.source = 'CashTap';
    }

    if (
      payload.imageUrl != '' &&
      payload.source != '' &&
      payload.email != ''
    ) {
      this.loaderService.show();
      this.apiCallService
        .PostCallWithToken(payload, 'Wallet/CreateWalletPaymentRequest')
        .subscribe({
          next: (response) => {
            if (response && response.responseCode === 200) {
              this.toastr.success(response.responseMessage, 'Success');
              this.getWalletBalance();
              this.loaderService.hide();
              this.hideWalletModal();
            } else {
              this.handleError.handleResponseError(response);
              // this.loaderService.hide();
              this.hideWalletModal();
            }
          },
          error: (error) => {
            this.handleError.handleHttpError(error);
            // this.loaderService.hide();
            this.hideWalletModal();
          },
        });
    } else {
      this.toastr.info(
        'Please Enter Amount, Upload image and Add Email',
        'Validation'
      );
    }
  }

  // Tap Tap Cash App auto methord
  // ShowCashapp2:boolean= false;
  // createTapTapPaylaod(){
  // const localEmail = localStorage.getItem('email') || '';
  // const localCustomerId = parseInt(localStorage.getItem('customerId') || '0', 10);
  // return {
  //   amount:  this.newBalance = 0,
  //   source: "",
  //   paymentProvider: "",
  //   email: localEmail,
  //   customerId: localCustomerId
  // };
  // }
  createTapTapPayload() {
    const localEmail = localStorage.getItem('email') || '';
    const localCustomerId = parseInt(localStorage.getItem('customerId') || '0', 10);

    // Logic for Source
    const source = this.selectedAccountType === 'CashApp2'
      ? 'TapTap,CashApp'
      : this.selectedAccountType;

    // Logic for Payment Provider
    let paymentProvider = "";
    const typeLower = this.selectedAccountType?.toLowerCase();

    if (typeLower === 'googlepay' || typeLower === 'applepay') {
      paymentProvider = typeLower;
    }

    return {
      amount: this.newBalance,
      source: source,
      paymentProvider: paymentProvider,
      email: localEmail,
      customerId: localCustomerId
    };
  }

  AddTapTapCashApp() {
    this.loaderService.show();
    const selectedAccountDetails = this.AccountType.find(
      (account: any) => account.name === this.selectedAccount
    );

    if (selectedAccountDetails) {
      const amount = this.newBalance || 0;
      const min = selectedAccountDetails.MinDepositLimit;
      const max = selectedAccountDetails.MaxDepositLimit;

      // 2. Perform the limit checks
      if (amount < min) {
        this.toastr.warning(`Error: Min Deposit for ${this.selectedAccount} is ${min}`, 'Invalid Amount');
        this.loaderService.hide();
        return
      }

      if (max > 0 && amount > max) {
        this.toastr.warning(`Error: Max Deposit for ${this.selectedAccount} is ${max}`, 'Invalid Amount');
        this.loaderService.hide();
        return
      }
    }
    const payload = this.createTapTapPayload();
    // Open a new blank tab immediately to prevent browser pop-up blockers
    const newTab = window.open('', '_blank');
    this.apiCallService.PostCallWithToken(payload, 'TapTapup/CreateTapTapPayment').subscribe({
      next: (response) => {
        if (response && response.responseCode === 200) {
          this.toastr.success(response.responseMessage, 'Success');
          if (newTab) {
            newTab.location.href = response.data.redirect_url; // Redirect the blank tab
          } else {
            window.open(response.data.redirect_url, '_blank'); // Fallback in case tab is blocked
          }
        } else {
          this.handleError.handleResponseError(response);
          if (newTab) newTab.close(); // Close the tab if API fails
        }
        this.loaderService.hide();
      },
      error: (error) => {
        this.handleError.handleHttpError(error);
        if (newTab) newTab.close(); // Close the tab on error
        this.loaderService.hide();
      },
    });
  }


  cashAppAmounts: number[] = [
    5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 18, 20, 25, 30, 31, 40, 50, 60, 100, 125, 130, 150, 200, 300, 400, 500
  ];

  googleApplePayAmounts: number[] = [
    4.99, 5.99, 6.99, 7.99, 8.99, 9.99, 10.99, 11.99, 12.99, 13.99,
    14.99, 15.99, 17.99, 19.99, 21.99, 24.99, 29.99, 30.99, 34.99,
    39.99, 41.99, 49.99, 54.99, 59.99, 69.99, 79.99, 99.99
  ];
}
